import { useEffect, useState } from "react";
import { navLinks } from "@/mocks/home";

export default function SiteHeader() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-background-50/90 backdrop-blur-md shadow-soft"
          : "bg-transparent"
      }`}
    >
      <nav className="container-site flex h-16 items-center justify-between">
        <a href="#top" className="flex items-center gap-2">
          <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-primary-500 text-background-50">
            <span className="text-xl">🍉</span>
          </span>
          <span className="text-lg font-black tracking-tight text-foreground-950">
            嗑瓜<span className="text-primary-600">星球</span>
          </span>
        </a>

        <ul className="hidden items-center gap-1 md:flex">
          {navLinks.map((l) => (
            <li key={l.id}>
              <a
                href={`#${l.id}`}
                className="rounded-full px-4 py-2 text-sm font-medium text-foreground-700 transition hover:bg-primary-100 hover:text-primary-700"
              >
                {l.label}
              </a>
            </li>
          ))}
        </ul>

        <div className="hidden items-center gap-3 md:flex">
          <a
            href="#hot"
            className="whitespace-nowrap rounded-md px-4 py-2 text-sm font-semibold text-foreground-800 transition hover:bg-background-100"
          >
            逛热榜
          </a>
          <a
            href="#treehole"
            className="whitespace-nowrap rounded-md bg-primary-500 px-5 py-2 text-sm font-bold text-background-50 transition hover:bg-primary-600"
          >
            去开席 <i className="ri-fire-line align-middle"></i>
          </a>
        </div>

        <button
          aria-label="打开菜单"
          onClick={() => setMenuOpen((v) => !v)}
          className="flex h-10 w-10 items-center justify-center rounded-md border border-background-200/70 bg-background-50 text-foreground-900 md:hidden"
        >
          <i className={menuOpen ? "ri-close-line text-xl" : "ri-menu-line text-xl"}></i>
        </button>
      </nav>

      {menuOpen && (
        <div className="animate-pop border-t border-background-200/70 bg-background-50 px-4 pb-6 pt-2 md:hidden">
          <ul className="flex flex-col">
            {navLinks.map((l) => (
              <li key={l.id}>
                <a
                  href={`#${l.id}`}
                  onClick={() => setMenuOpen(false)}
                  className="block border-b border-background-100 px-2 py-3 text-sm font-medium text-foreground-800"
                >
                  {l.label}
                </a>
              </li>
            ))}
          </ul>
          <a
            href="#treehole"
            onClick={() => setMenuOpen(false)}
            className="mt-4 flex w-full items-center justify-center whitespace-nowrap rounded-md bg-primary-500 px-5 py-3 text-sm font-bold text-background-50"
          >
            去开席 <i className="ri-fire-line align-middle ml-1"></i>
          </a>
        </div>
      )}
    </header>
  );
}